import { motion } from "framer-motion";
import { testimonials } from "../data/site";

function Stars({ n }) {
    return (
        <div className="flex gap-1 text-[#E2C56D] text-sm">
            {Array.from({ length: n }).map((_, i) => (
                <span key={i}>★</span>
            ))}
        </div>
    );
}

export default function Testimonials() {
    return (
        <section
            id="testimonials"
            className="relative bg-[#111111] py-24 md:py-40 px-6 md:px-10 border-y border-[rgba(212,175,55,0.2)] overflow-hidden"
            data-testid="testimonials-section"
        >
            {/* Giant quotation mark */}
            <div
                aria-hidden
                className="pointer-events-none absolute -top-16 -left-6 md:-left-16 font-display text-[45vw] md:text-[26vw] leading-none text-[#C89B3C]/[0.06] select-none"
            >
                “
            </div>

            <div className="mx-auto max-w-[1440px] relative">
                <div className="flex items-center gap-6 mb-10">
                    <span className="w-16 h-px bg-[#C89B3C]" />
                    <span className="text-[10px] uppercase tracking-[0.4em] text-[#C89B3C]">
                        Chapter 14 — Voices
                    </span>
                </div>

                <motion.h2
                    initial={{ opacity: 0, y: 30 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    viewport={{ once: true, margin: "-15%" }}
                    transition={{ duration: 0.9 }}
                    className="font-display font-light text-white text-5xl md:text-6xl lg:text-7xl leading-[0.95] tracking-tight max-w-4xl"
                >
                    What our residents <em className="text-[#E2C56D]">say.</em>
                </motion.h2>

                <div className="mt-16 grid grid-cols-1 md:grid-cols-3 gap-6 md:gap-8">
                    {testimonials.map((t, i) => (
                        <motion.figure
                            key={i}
                            initial={{ opacity: 0, y: 30 }}
                            whileInView={{ opacity: 1, y: 0 }}
                            viewport={{ once: true, margin: "-15%" }}
                            transition={{ duration: 0.8, delay: i * 0.12 }}
                            className={`group relative p-8 md:p-10 border border-[rgba(212,175,55,0.25)] bg-[#0b0b0b]/60 backdrop-blur-xl hover:border-[#C89B3C] transition-colors duration-500 ${
                                i === 1 ? "md:translate-y-8" : ""
                            }`}
                            data-testid={`testimonial-${i}`}
                        >
                            <div className="flex items-center justify-between mb-6">
                                <Stars n={t.stars} />
                                <span className="text-[10px] uppercase tracking-[0.35em] text-[#7a7a7a]">
                                    № {String(i + 1).padStart(2, "0")}
                                </span>
                            </div>
                            <blockquote className="font-serif-alt text-white text-xl md:text-2xl leading-snug tracking-tight">
                                “{t.quote}”
                            </blockquote>
                            <figcaption className="mt-10 pt-6 border-t border-[rgba(212,175,55,0.2)] flex items-center gap-4">
                                <div className="w-10 h-10 rounded-full border border-[rgba(212,175,55,0.55)] flex items-center justify-center text-[#E2C56D] font-display">
                                    {t.author.charAt(0)}
                                </div>
                                <div>
                                    <div className="text-white font-display">{t.author}</div>
                                    <div className="text-[11px] uppercase tracking-[0.25em] text-[#bebebe]">
                                        {t.role}
                                    </div>
                                </div>
                            </figcaption>
                        </motion.figure>
                    ))}
                </div>
            </div>
        </section>
    );
}
